import { node, object, oneOfType, string } from 'prop-types';
import React from 'react';
import { Cell } from 'react-sticky-table';

import styles from './style';

const TableCaption = ({ style, position, children, ...rest }) => {
  const styleCol = {
    ...style,
    ...styles.caption,
    captionSide: position
  };
  return (
    <Cell style={styleCol} {...rest}>
      {children}
    </Cell>
  );
};

TableCaption.propTypes = {
  style: object,
  position: string,
  children: oneOfType([node, string])
};

TableCaption.defaultProps = {
  style: {},
  position: 'bottom',
  children: null
};

export default TableCaption;
